export const CALL_PROGRAMS_LIST_PROTOCOLS = [
  {
    value: 'tel://',
    name: 'Default',
  },
  {
    value: 'Skype://',
    name: 'skypeto',
  },
]
